// extracted by mini-css-extract-plugin
module.exports = {"container":"style_container__lNfya","label":"style_label__kx9qu"};